<template>
	<div class="twitter-share-link">
		<a :href="link" title="E-mail"><i class="fa fa-envelope"></i></a>
	</div>
</template>

<script type="text/javascript">
export default{
	name: 'EmailShare',
	props: ['href'],
	data: function(){
		return {
			link: 'mailto:?subject=Confira este post&amp;body=Confira este post '+this.href
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/assets/vue/components/share/EmailShare.vue